module.exports = __webpack_public_path__ + "static/buses-daaf7f97aae4e0efd1f72a639f0d894e.png";